
namespace GeniuzPOS.Points {

    @Serenity.Decorators.registerClass()
    export class MemberTypeGrid extends Serenity.EntityGrid<MemberTypeRow, any> {
        protected getColumnsKey() { return MemberTypeColumns.columnsKey; }
        protected getDialogType() { return MemberTypeDialog; }
        protected getIdProperty() { return MemberTypeRow.idProperty; }
        protected getInsertPermission() { return MemberTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return MemberTypeRow.localTextPrefix; }
        protected getService() { return MemberTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(){
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }
    }
}